import React from 'react';

import EOTResult from '../EoT/EoTResult'

import { summarizeRoll } from '../EoT/EoTResultSummary'

/*  -- Order of Sorting --
    triumpDispair,
    successFail,
    advantageThreat,
    blackWhite
*/

var sortFunction = (a, b) => {
  if (a.triumpDispair.length + b.triumpDispair.length > 0) {
    return (b.triumpDispair.filter(i=>i==='R').length - b.triumpDispair.filter(i=>i==='D').length)
            - (a.triumpDispair.filter(i=>i==='R').length - a.triumpDispair.filter(i=>i==='D').length)

  } else if (a.successFail.length + b.successFail.length > 0) {
    return (b.successFail.filter(i=>i==='S').length - b.successFail.filter(i=>i==='F').length)
            - (a.successFail.filter(i=>i==='S').length - a.successFail.filter(i=>i==='F').length)

  } else if (a.advantageThreat.length + b.advantageThreat.length > 0) {
    return (b.advantageThreat.filter(i=>i==='A').length - b.advantageThreat.filter(i=>i==='T').length)
            - (a.advantageThreat.filter(i=>i==='A').length - a.advantageThreat.filter(i=>i==='T').length)

  } else if (a.blackWhite.length + b.blackWhite.length > 0) {
    return (b.blackWhite.filter(i=>i==='W').length - b.blackWhite.filter(i=>i==='B').length)
            - (a.blackWhite.filter(i=>i==='W').length - a.blackWhite.filter(i=>i==='B').length)
  }

  return 0;
}


export default ({results}) => {

  var toSort = [];
  Object.keys(results).forEach(key => {
    toSort.push([key, summarizeRoll(results[key])]);
  });

  toSort.sort((a, b) => sortFunction(a[1], b[1]));


  return (<div>
      {toSort.map(r=>results[r[0]]).map(r =>
        <EOTResult key={r.key} result={r} />
      )}
    </div>)
}



// WEBPACK FOOTER //
// ./src/RollResults/ActionBar/SortedResults.js